import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    endpoint: "http://18.208.164.251/api",
  },
  mutations: {

  },
  actions: {

  }
})



// WEBPACK FOOTER //
// ./src/components/store.js